import React from 'react';
import { AlertCircle } from 'lucide-react';

const ModuleAlert = ({ message }) => {
  if (!message) return null;
  return (
    <div className="module-alert" role="alert">
      <AlertCircle className="w-4 h-4 shrink-0" />
      <span>{message}</span>
    </div>
  );
};

export default ModuleAlert;
